var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShorts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3B55E6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 19,
    className: "st0",
    width: 2,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 19,
    className: "st0",
    width: 2,
    height: 6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104,27H16c-0.55,0-1-0.45-1-1v-6c0-0.55,0.45-1,1-1h88c0.55,0,1,0.45,1,1v6C105,26.55,104.55,27,104,27z  M17,25h86v-4H17V25z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116,101H70c-0.49,0-0.91-0.35-0.99-0.84l-5.34-32.05C63.37,66.31,61.83,65,60,65s-3.37,1.31-3.67,3.11 l-5.34,32.05c-0.08,0.48-0.5,0.84-0.99,0.84H4c-0.28,0-0.55-0.12-0.74-0.33c-0.19-0.21-0.28-0.49-0.25-0.77l6-60 c0.01-0.1,0.04-0.2,0.08-0.29l6-14C15.24,25.24,15.6,25,16,25h88c0.4,0,0.76,0.24,0.92,0.61l6,14c0.04,0.09,0.07,0.19,0.08,0.29 l6,60c0.03,0.28-0.06,0.56-0.25,0.77C116.55,100.88,116.28,101,116,101z M70.85,99h44.05l-5.87-58.75L103.34,27H16.66 l-5.68,13.25L5.11,99h44.05l5.2-31.22C54.82,65.01,57.19,63,60,63s5.18,2.01,5.64,4.78L70.85,99z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.04,54.73 7.8,53.16 17.55,45.44 24.8,25 26.68,25.67 19.25,46.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "110.96,54.73 100.75,46.65 93.32,25.67 95.2,25 102.45,45.44 112.2,53.16  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShorts);
export default __webpack_public_path__ + "static/media/shorts.562c91d37e1307df69b989e37c6a4550.svg";
export { ForwardRef as ReactComponent };